import { render } from "./TicketListDetail.vue?vue&type=template&id=6cfe2c35"
import script from "./TicketListDetail.vue?vue&type=script&lang=js"
export * from "./TicketListDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__